import { Fragment, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useRoutes, getSequenceOfParentRoutes } from '@lucan/base-ui'

export default function UrlSwitchContextProvider({ children }) {
  const { pathname: pathCorrente } = useLocation()
  const { findRouteWithPath } = useRoutes()

  const CurrentProvider = useMemo(() => {
    const rottaCorrente = findRouteWithPath(pathCorrente)
    const rottaRadice = getSequenceOfParentRoutes(rottaCorrente)[0]
    const servizioProvider = rottaRadice?.Provider ?? null
    return servizioProvider || Fragment
  }, [pathCorrente, findRouteWithPath])

  return <CurrentProvider>{children}</CurrentProvider>
}